<template>
  <v-container>
    <h1>{{ get("header-1") }}</h1>
    <parameter ref="param" @error="onError" @id="onId"></parameter>
  </v-container>
</template>

<script>
import localizationMixin from "@/mixins/localization-mixin";
import paramCtrl from "@/components/controls/parameter";
import settingsService from "@/_services/settings-service";

export default {
  name: "account-registered",

  components: {
    "parameter": paramCtrl,
  },

    created() {
    this.pageName = "registered";
  },

  mixins: [localizationMixin],

  mounted() {
    console.log('registered.mounted()', this.$route.params.id);
    this.$refs.param.get(this.$route.params.id);
  },

  methods: {
    onData(data) {
      const user = {
        applicationId: settingsService.get("applicationId"),
        username: data.username,
        password: "",
        returnUrl: settingsService.get("verifiedUrl"),
        title: "Verify Registration",
        cancelUrl: settingsService.get("cancelUrl"),
      };
      this.$refs.param.create(user);
    },

    onError(error) {
      console.log(error);
    },

    getLocalization(){},

    onId(id) {
      console.log("registered.onId()", id);
      window.location.href = settingsService.get("remoteVerifyUrl") + id;
    }
  }
}
</script>

<style>

</style>